import { Reducer } from 'redux';
import { EulaActionTypes, EulaState } from './types';

export const initialState: EulaState = {
  process: 'initial',
  eulaContent: ''
};

const reducer: Reducer<EulaState> = (state = initialState, action: any) => {
  switch (action.type) {
    case EulaActionTypes.GET_EULA_START: {
      return {
        ...state,
        process: 'loading'
      };
    }
    case EulaActionTypes.GET_EULA_SUCCESS: {
      return {
        ...state,
        process: 'loaded',
        eulaContent: action.payload
      };
    }
    case EulaActionTypes.GET_EULA_FAILURE: {
      return {
        ...state,
        process: 'fail',
        error: action.payload
      };
    }
    case EulaActionTypes.ACCEPT_EULA_START: {
      return {
        ...state,
        process: 'accepting'
      };
    }
    case EulaActionTypes.ACCEPT_EULA_SUCCESS: {
      return {
        ...state,
        process: 'success'
      };
    }
    case EulaActionTypes.ACCEPT_EULA_FAILURE: {
      return {
        ...state,
        process: 'fail',
        error: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
